import get from 'lodash/get';

export default {
  get(key) {
    return get(window.setappConfig, key.split('.'));
  },
};
